/**
 * Candidate-rejection errors, traced from `AtsApplicationsController#reject` /
 * `#bulk_reject` and the validators they call.
 *
 * Only codes belong here. Raises that pass `I18n.t(...)` arrive as finished
 * sentences and print verbatim — candidate email missing, delegation disabled,
 * mailbox not connected, the `missing_*` params. The rest raise the BARE key,
 * and with no entry the user gets the generic fallback instead.
 */
export default {
  // Survey / body pairing — the backend rejects either half alone.
  err_survey_link_required_in_email_body: {
    message:
      'This email includes a survey but no survey link. Add the link to the body, or remove the survey.',
  },
  err_survey_link_requires_form_template: {
    message:
      'This email has a survey link but no survey selected. Pick a survey, or remove the link from the body.',
  },

  // The selected survey itself.
  err_survey_form_template_required: {
    message: 'Select a survey before sending this rejection.',
  },
  err_survey_form_template_not_found: {
    message:
      'That survey no longer exists. Pick a different one, or remove the survey link from the body.',
  },
  err_survey_form_template_not_published: {
    message:
      'That survey is still a draft. Publish it before sending it to candidates, or pick a published one.',
  },
  err_survey_form_template_must_be_candidate_type: {
    message:
      'Only candidate surveys can be sent with a rejection. Pick a candidate survey instead.',
  },

  // Sender / mailbox.
  err_missing_sender_id: {
    message: 'Choose who this email is sent from.',
  },
  err_invalid_ats_shared_email_id: {
    message:
      'You no longer have access to that shared mailbox. Pick a different sender.',
  },
  err_user_not_found: {
    message: 'The selected sender no longer exists. Pick a different sender.',
  },

  // Scheduling.
  err_invalid_timezone: {
    message: 'That timezone is not recognised. Pick one from the list.',
  },

  // Project add-on: the rejection succeeds, only the project add fails.
  err_project_prospect_exists: {
    message:
      'Candidate already added to the project. Try rejecting them without adding them to a project, or add them to a different project.',
  },
  err_project_not_found: {
    message:
      'That project no longer exists. Pick a different one, or reject without adding to a project.',
  },

  // Referenced records.
  err_ats_rejection_reason_not_found: {
    message: 'That rejection reason no longer exists. Pick a different one.',
  },
  err_ats_comm_template_not_found: {
    message: 'That email template no longer exists. Pick a different one.',
  },

  // Catch-alls: the `reject` rescue's fallback, and the bare token bulk
  // attaches per failed application.
  err_unprocessable_entity: {
    message: 'This candidate could not be rejected. Try again.',
  },
  unprocessable_entity: {
    message: 'This candidate could not be rejected. Try again.',
  },
};
